import LinkMockExamPanel from './LinkMockExamPanel.gql';

export default LinkMockExamPanel;
